import { API } from '@/api/API'
import { loginAndTransferCart } from '@/state/Cart'

/** This method is defined separately from AuthenticationMethod because it isn't configurable from the CMS. Instead, it is available when AuthenticationMethod is `password`, and has to be used directly in the API call  */
export type OTPAuthMethod = typeof OTP_AUTH_METHOD
const OTP_AUTH_METHOD = 'otp_ecomm'

type OTPRequestPayload = {
  email: string
  provider: 'tix'
  state?: string
}

type OTPLoginPayload = {
  token: string
  otp: string
  method: OTPAuthMethod
}

export async function requestOTP(payload: Omit<OTPRequestPayload, 'provider'>): Promise<string> {
  const body: OTPRequestPayload = { ...payload, provider: 'tix' }
  const response = await API.post<'token'>('login/request_otp', { body })
  return response.token
}

export function loginWithOTP(credentials: Omit<OTPLoginPayload, 'method'>) {
  return loginAndTransferCart(credentials, OTP_AUTH_METHOD)
}
